import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10 20C4.49 20 0 15.51 0 10S4.49 0 10 0s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67A2.5 2.5 0 0 1 10 20Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5a.54.54 0 0 0-.14-.35c-.41-.46-.63-1.05-.63-1.65a2.5 2.5 0 0 1 2.5-2.5H14c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7Z" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M4.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM7.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM12.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM15.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }